const toastMessages = (type, additionalInfo) => {
  switch (type) {
    case 'onSizeError':
      return {
        type: 'error',
        message: `Insira um anexo de até ${additionalInfo}MB`,
        closeTime: 6000,
      };
    case 'onFileError':
      return {
        type: 'error',
        message: `Insira um anexo em formato ${additionalInfo.toUpperCase()}`,
        closeTime: 8000,
      };
    case 'defaultError':
      return {
        type: 'error',
        message: 'Não foi possível inserir o seu anexo. Por favor tente novamente',
        closeTime: 8000,
      };
    case 'onSuccess':
      return {
        type: 'success',
        message: `Anexo ${additionalInfo} inserido`,
        closeTime: 6000,
      };
    case 'onRemove':
      return {
        type: 'information',
        message: 'Arquivo removido',
        closeTime: 6000,
      };
    default:
      return {
        type: 'information',
        message: 'Sucesso',
        closeTime: 3000,
      };
  }
};

export { toastMessages };
